import { render, staticRenderFns } from "./BaseUploadSingle.vue?vue&type=template&id=33c184c0&scoped=true"
import script from "./BaseUploadSingle.vue?vue&type=script&lang=js"
export * from "./BaseUploadSingle.vue?vue&type=script&lang=js"
import style0 from "./BaseUploadSingle.vue?vue&type=style&index=0&id=33c184c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c184c0",
  null
  
)

export default component.exports